import { inject, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { KeycloakService } from "@ogs/ngx-keycloak";
import { filter } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class DialogService {
  private readonly _keycloakService: KeycloakService = inject(KeycloakService);

  private readonly _dialog: MatDialog = inject(MatDialog);

  public constructor () {
    this._keycloakService
      .isAuthorized$()
      .pipe(
        filter((isAuthorized: boolean) => !isAuthorized)
      )
      .subscribe(() => this._dialog.closeAll());
  }
}
